import React from 'react';
import {GeoFaqItem} from '../../data/geoContent.mock';

type GeoFaqSectionProps = {
    cityName: string;
    items: GeoFaqItem[];
    variant?: 'default' | 'accordion';
};

const GeoFaqSection: React.FC<GeoFaqSectionProps> = ({
    cityName,
    items,
    variant = 'default',
}) => {
    if (items.length === 0) {
        return null;
    }

    if (variant === 'accordion') {
        return (
            <section className="geo-faq geo-faq--accordion" aria-labelledby="geo-faq-heading">
                <h2 id="geo-faq-heading">FAQ — {cityName}</h2>
                <div className="geo-faq-accordion">
                    {items.map((item) => (
                        <details className="geo-faq-accordion__item" key={item.question}>
                            <summary>{item.question}</summary>
                            <p>{item.answer}</p>
                        </details>
                    ))}
                </div>
            </section>
        );
    }

    return (
        <section className="geo-faq" aria-labelledby="geo-faq-heading">
            <h2 id="geo-faq-heading">Frequently asked questions — {cityName}</h2>
            {items.map((item) => (
                <article className="geo-faq-item" key={item.question}>
                    <h3>{item.question}</h3>
                    <p>{item.answer}</p>
                </article>
            ))}
        </section>
    );
};

export default GeoFaqSection;
